import React, { memo } from 'react';
import { formGroup, formControl, FormDataType } from '@core/utils/form';
import { CBody } from '@modules/common/CBody';
import { FormSelect } from '@core/components/form';
import { WidgetConfirmProps } from '../types';
import { CardTitle } from 'reactstrap';

export function defineFunnelWidgetConfigForm() {
  return formGroup({
    sort: formControl<string>({ label: 'Funnel Sorting', initialValue: 'descending' }),
  });
}

export type FunnelWidgetConfigType = ReturnType<typeof defineFunnelWidgetConfigForm>;
export type FunnelWidgetConfigData = FormDataType<typeof defineFunnelWidgetConfigForm>;

export const FunnelWidgetConfig = memo((props: WidgetConfirmProps<FunnelWidgetConfigType, FunnelWidgetConfigData>) => {
  const { form, data } = props;
  return (
    <CBody>
      <CardTitle>Widget UI Settings</CardTitle>
      <FormSelect
        type="single"
        control={form.controls.sort}
        items={[
          { label: 'Ascending', value: 'ascending' },
          { label: 'Descending', value: 'descending' },
          { label: 'Data Order', value: 'none' },
        ]}
      />
    </CBody>
  );
});
